import { clearPrefetches, defineNuxtRouteMiddleware, isAccessTokenFresh, prefetchRoute, useNuxtApp } from '#imports'

// First in the chain, so a client navigation starts its queries before middleware awaits anything.
export default defineNuxtRouteMiddleware((to, from) => {
    const nuxtApp = useNuxtApp()

    // The server prefetches the page it renders; a query-only change (auth dialog) loads nothing new.
    if (import.meta.server || nuxtApp.isHydrating || to.path === from.path) return

    clearPrefetches(nuxtApp)
    prefetchRoute(to, { accessTokenFresh: isAccessTokenFresh(), from })
})
